export const calculateDaysDifference = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  
  const timeDifference = end.getTime() - start.getTime();
  return Math.floor(timeDifference / (1000 * 3600 * 24));
};

export const calculateDetailedDifference = (startDate, endDate) => {
  if (!startDate || !endDate) {
    return { years: 0, months: 0, days: 0 };
  }

  let years = endDate.getFullYear() - startDate.getFullYear();
  let months = endDate.getMonth() - startDate.getMonth();
  let days = endDate.getDate() - startDate.getDate();

  if (days < 0) {
    months--;
    const lastDayOfMonth = new Date(
      endDate.getFullYear(),
      endDate.getMonth(),
      0
    ).getDate();
    days += lastDayOfMonth;
  }

  if (months < 0) {
    years--;
    months += 12;
  }

  return { years, months, days };
};

export const calculateWorkdaysDifference = (startDate, endDate) => {
  let count = 0;
  let startDate2 = new Date(startDate);
  let endDate2 = new Date(endDate);
  
  // Ensure start is before end
  if (startDate2 > endDate2) {
    // Swap dates if start is after end
    const temp = startDate2;
    startDate2 = endDate2;
    endDate2 = temp;
  }
  
  const current = new Date(startDate2);
  
  while (current <= endDate2) {
    const dayOfWeek = current.getDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) { // Not Sunday (0) or Saturday (6)
      count++;
    }
    current.setDate(current.getDate() + 1);
  }
  
  return count;
};